export { GenericCard } from "./generic-card";
export { GenericCardContent } from "./generic-card-content";
export type { GenericCardProps } from "./generic-card";
